import React from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image";

import './Article.scss';
import Layout from '../layouts/default';
import SEO from '../components/seo';
import { Col, Container, Row } from 'react-bootstrap';
import Html from '../components/paragraph/html';
import { formatTime } from '../components/functions';

export default ({ data }) => {
  const node = data.allNodeArticle.edges[0].node;
  const date = formatTime(node.created).split(' ');

  //console.log(node);

  return (
    <Layout>
      <SEO
        title={node.title}
        description={node.field_summary}
        image={
          node.relationships.field_image.relationships
            .field_media_image.localFile.publicURL
        }
      />
      <div id={node.id} className={'entry-article'}>
        <Container>
          <Row>
            <Col>
              <h1>{node.title}</h1>
              <p>
                <b>{node.field_summary}</b>
              </p>
            </Col>
          </Row>
        </Container>
        {/* Display the image only if checked */}
        {node.field_display_image && node.relationships.field_image && (
          <Container>
            <Row>
              <Col>
                <GatsbyImage
                  image={{
                    ...node.relationships.field_image.relationships
                      .field_media_image.localFile.childImageSharp.gatsbyImageData,
                    aspectRatio: 2,
                  }}
                  className="d-block w-100"
                  imgStyle={{ objectFit: 'cover' }}
                  alt={
                    node.relationships.field_image.field_media_image
                      .alt
                  } />
              </Col>
            </Row>
          </Container>
        )}
        <Container>
          <Row
            className={
              'justify-content-start justify-content-md-center'
            }
          >
            <div
              className={'article-date d-md-block text-right d-none'}
            >
              <p>{date[0]}</p>
              <p>{date[1]}</p>
              <p>{date[2]}</p>
            </div>
            <div className={'article-date text-left d-md-none'}>
              <p style={{ margin: 0 }}>
                {date[0]} {date[1]}, {date[2]}
              </p>
            </div>
            <Col xs={12} md={9}>
              {node.relationships.field_article_body.map(
                (item, index) => {
                  // console.log(item)
                  switch (item.internal.type) {
                    case 'paragraph__component_html':
                      return (
                        <Html props={item.field_html} key={index} />
                      );
                    default:
                      return <p>Article content not found</p>;
                  }
                }
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export const query = graphql`query ($id: String!) {
  allNodeArticle(filter: {id: {eq: $id}}) {
    edges {
      node {
        id
        created
        title
        field_summary
        field_display_image
        relationships {
          field_article_body {
            internal {
              type
            }
            field_html {
              processed
              value
            }
          }
          field_image {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
